import { resourceFromAttributes } from '@opentelemetry/resources'
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from '@opentelemetry/semantic-conventions'

import env from './env'
import { ATTR_SERVICE_NAMESPACE } from './semconv'
import {
    setupMeterProvider,
    setupTraceInstrumentations,
    setupTracerProvider,
    trackBrowserLongTasks,
    trackBundleSize,
    trackMemoryConsumption,
    trackWebVitals,
} from './utils/observability'

function setupOtel() {
    if (!env.VITE_ENABLE_OTEL) return

    const resource = resourceFromAttributes({
        // Match OTEL_RESOURCE_ATTRIBUTES for backend services.
        [ATTR_SERVICE_NAME]: 'frontend',
        [ATTR_SERVICE_VERSION]: env.VITE_GIT_SHA ?? 'N/A',
        [ATTR_SERVICE_NAMESPACE]: env.VITE_OTEL_SERVICE_NAMESPACE ?? 'unknown',
        // Custom client attributes
        ['di.tenant.name']: env.VITE_TENANT_NAME ?? 'unknown',
    })

    if (env.VITE_OTEL_TRACE_ENDPOINT) {
        setupTracerProvider(resource)
        setupTraceInstrumentations()
    } else {
        console.warn('OTel enabled but no collector url configured (VITE_OTEL_TRACE_ENDPOINT)')
    }

    if (env.VITE_OTEL_METRICS_ENDPOINT) {
        setupMeterProvider(resource)

        trackWebVitals()
        trackMemoryConsumption()
        trackBrowserLongTasks()
        trackBundleSize()
    } else {
        console.warn('OTel enabled but no collector url configured (VITE_OTEL_METRICS_ENDPOINT)')
    }

    // Outstanding things:
    // - Our router navigation needs to be instrumented!
    // - We should also add OTEL logging integration
}

setupOtel()
